import axios from "axios";
import { API_BASE_URL } from '../config';

const UpdateQuestionServices = async (token, selection) => {
    try {
        if (!token) {
            throw new Error('No token available');
        }

        const response = await axios.post(`${API_BASE_URL}changesQuestions/`,
        {
            bloque: selection
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        return response.status;
    } catch (error) {
        throw new Error(error);
    }
}

export default UpdateQuestionServices;